import logo1998 from "../../assets/img/historicEvents/LogoUnforgiven/1998.png";
import logo1999 from "../../assets/img/historicEvents/LogoUnforgiven/1999.png";
import logo2000_2001 from "../../assets/img/historicEvents/LogoUnforgiven/2000-2001.png";
import logo2002 from "../../assets/img/historicEvents/LogoUnforgiven/2002.png";
import logo2003 from "../../assets/img/historicEvents/LogoUnforgiven/2003.png";
import logo2004 from "../../assets/img/historicEvents/LogoUnforgiven/2004.png";
import logo2005_2006 from "../../assets/img/historicEvents/LogoUnforgiven/2005-2006.png";
import logo2007 from "../../assets/img/historicEvents/LogoUnforgiven/2007.png";
import logo2008 from "../../assets/img/historicEvents/LogoUnforgiven/2008.png";

export const unforgivenDetail = {
  unforgiven: {
    id: "unforgiven",
    title: "Unforgiven",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "unforgiven",
        items: [
          {
            id: "unforgiven-1998",
            title: "Unforgiven",
            description: "In Your House 1998",
            imgUrl: logo1998,
          },
          {
            id: "unforgiven-1999",
            title: "Unforgiven",
            description: "Their Soul Will Remain Unforgiven 1999",
            imgUrl: logo1999,
          },
          {
            id: "unforgiven-2000",
            title: "Unforgiven",
            description: "2000",
            imgUrl: logo2000_2001,
          },
          {
            id: "unforgiven-2001",
            title: "Unforgiven",
            description: "The Greatest of Battles are Fought from Within. 2001",
            imgUrl: logo2000_2001,
          },
          {
            id: "unforgiven-2002",
            title: "Unforgiven",
            description: "The Next Big Thing has arrived 2002",
            imgUrl: logo2002,
          },
          {
            id: "unforgiven-2003",
            title: "Unforgiven",
            description: "Face Your Fear 2003",
            imgUrl: logo2003,
          },
          {
            id: "unforgiven-2004",
            title: "Unforgiven",
            description: "Insane. Pain. Kane. 2004",
            imgUrl: logo2004,
          },
          {
            id: "unforgiven-2005",
            title: "Unforgiven",
            description: "2005 - 2006",
            imgUrl: logo2005_2006,
          },
          {
            id: "unforgiven-2007",
            title: "Unforgiven",
            description: "2007",
            imgUrl: logo2007,
          },
          {
            id: "unforgiven-2008",
            title: "Unforgiven",
            description: "2008",
            imgUrl: logo2008,
          },
        ],
      },
    ],
  },
};
